import React from "react";
import defaultCustomerLogo from "../assets/odp.png";

export default function CustomerBranding({ logoSrc, alt, name, subtitle }) {
  return (
    <div className="flex flex-col items-center gap-2 md:gap-4 flex-shrink-0 md:mr-0">
      <div className="w-[150px] md:w-[240px] h-[100px] md:h-[180px] flex items-center justify-center">
        <img
          src={logoSrc && logoSrc.trim() ? logoSrc : defaultCustomerLogo}
          alt={alt || "Logo"}
          className="max-w-full max-h-full w-auto h-auto object-contain"
          draggable={false}
          onError={(e) => {
            if (e.target.src !== defaultCustomerLogo) {
              e.target.src = defaultCustomerLogo;
            }
          }}
        />
      </div>
      {name && (
        <div className="text-xl md:text-2xl font-bold text-slate-400 text-center text-[#3A4A51] leading-tight hidden md:block">
          {name}
        </div>
      )}
      {subtitle && (
        <div className="text-xs md:text-sm text-slate-500 text-center hidden md:block">
          {subtitle}
        </div>
      )}
    </div>
  );
}
